import SwitchingCategoriesIcon from "../../../assets/Switching/switchingCategoriesIcon.svg";
import type { ProductGroup } from "../../../types";

export const professional: ProductGroup = {
  id: "professional",
  title: "productGroup.professional.title",
  icon: {
    src: SwitchingCategoriesIcon,
    width: 64,
    height: 40,
  },
};
